<template>
  <ValidationObserver
    ref="signupFormObserver"
    v-slot="{ valid }"
  >
    <VTextField
      :ref="$utils.generateRandomString"
      v-model="data.email"
      :label="$t('forms.labels.email')"
      type="email"
      :rules="{ required: false }"
      :disabled="true"
      :dark="true"
      color="#ffffff"
    />
    <VPassword
      :ref="$utils.generateRandomString"
      v-model="data.password"
      :label="$t('forms.labels.password')"
      :passwordConfirm="true"
      :dark="true"
      color="#ffffff"
    />
    <SlotScopeWatcher
      :value="valid"
      @change="$emit('validChanged', valid)"
    />
  </ValidationObserver>
</template>

<script>
import { ValidationObserver } from 'vee-validate';
import validationProviderHelperMixin from '@/components/shared/widgets/forms/validationHelper/validationProviderHelperMixin';
import SlotScopeWatcher from '@/components/shared/widgets/forms/validationHelper/SlotScopeWatcher';
import VTextField from '@/components/shared/widgets/forms/VuetifyInputs/VTextField.vue';
import VPassword from '@/components/shared/widgets/forms/VuetifyInputs/VPassword.vue';

export default {
    components: {
        ValidationObserver,
        SlotScopeWatcher,
        VTextField,
        VPassword,
    },
    mixins: [
        validationProviderHelperMixin,
    ],
    data() {
        return {
            data: {
                email: '',
                password: '',
                code: '',
            },
        };
    },
    watch: {
        data: {
            handler() {
                this.updateData();
            },
            deep: true,
        },
    },
    created() {
        const { email, code } = JSON.parse(window.atob(this.$store.getters.resetPwdCode));
        this.data.email = email.shift();
        this.data.code = code;
    },
    methods: {
        updateData() {
            this.$emit('sendData', this.data);
        },
    },
};
</script>
